import * as React from 'react';
import { cn } from '@/lib/utils';

export type BadgeVariant =
  | 'default'
  | 'secondary'
  | 'destructive'
  | 'outline'
  | 'success'
  | 'warning'
  | 'danger'
  | 'info'
  | 'teal'
  | 'purple';

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: BadgeVariant;
}

export function Badge({ className, variant = 'default', ...props }: BadgeProps) {
  return (
    <div
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-medium transition-colors',
        variant === 'default'     && 'bg-primary text-primary-foreground',
        variant === 'secondary'   && 'bg-secondary text-secondary-foreground',
        variant === 'destructive' && 'bg-destructive text-destructive-foreground',
        variant === 'outline'     && 'border border-border text-foreground',
        // CUBIX semantic variants
        variant === 'success'     && 'bg-cx-success-light text-cx-success',
        variant === 'warning'     && 'bg-cx-warning-light text-cx-warning',
        variant === 'danger'      && 'bg-cx-danger-light text-cx-danger',
        variant === 'info'        && 'bg-cx-blue-light text-cx-blue',
        variant === 'teal'        && 'bg-cx-teal-light text-cx-teal',
        variant === 'purple'      && 'bg-cx-purple-light text-cx-purple',
        className,
      )}
      {...props}
    />
  );
}
